module.exports = __webpack_public_path__ + "img/logout.143ef0db.svg";